import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { FormattedMessage } from "react-intl";
import { colors, margins } from "style";
import { PrimaryLink } from "components/Links";
import { shortenText } from "utils";

const MAX_DISPLAY_CHARACTERS = 150;

/**
 * DailyReportResponse
 * Displays a single participant's response to a question
 *
 * @param {Object}   response           // The response from participant on any question
 * @param {Boolean}  isBlocker          // Whether the question is a general/impediment question
 */
const DailyReportResponse = ({ response, isBlocker }) => {
  const { answer } = response;

  if (!answer) return "-";

  const [isExpanded, setIsExpanded] = useState(false);

  const displayText = isExpanded ? answer : shortenText(answer, MAX_DISPLAY_CHARACTERS);
  const shouldShowToggle = answer && answer.length > MAX_DISPLAY_CHARACTERS;

  return (
    <AnswerText isBlocker={isBlocker}>
      {displayText}
      {shouldShowToggle && !isExpanded && "..."}
      {shouldShowToggle && (
        <StyledPrimaryLink onClick={() => setIsExpanded(!isExpanded)}>
          <FormattedMessage id={`Squads.Squad.DailyReport.Response.Show${isExpanded ? "Less" : "More"}`} />
        </StyledPrimaryLink>
      )}
    </AnswerText>
  );
};

const AnswerText = styled.p`
  color: ${({ isBlocker }) => (isBlocker ? colors.red : colors.grayAnatomyDark2)};
  line-height: 1.4;
  white-space: pre-wrap;
  margin: 0;
`;

const StyledPrimaryLink = styled(PrimaryLink)`
  margin-left: ${margins.xxsmall};
`;

DailyReportResponse.propTypes = {
  response: PropTypes.shape({
    answer: PropTypes.string,
  }).isRequired,
  isBlocker: PropTypes.bool,
};

export default DailyReportResponse;
